const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  id: state => state.user.id,
  email: state => state.user.email,
  name: state => state.user.name,
  username: state => state.user.username,
  microsoftid: state => state.user.microsoft_id,
  roles: state => state.user.roles,
  authenticated: state => state.user.authenticated,
  accountid: state => state.account.accountid,
  accountName: state => state.account.name,
  accountAddress: state => state.account.address,
  accountBetreuer: state => state.account.betreuer,
  aiEnabled: state => state.account.aiEnabled,
  departments: state => state.account.departments,
  systems: state => state.account.systems,
  personGroups: state => state.account.personGroups,
  dataTypes: state => state.account.dataTypes,
  suppliers: state => state.account.suppliers,
  vts: state => state.data.vts,
  abbreviations: state => state.account.abbreviations,
  modalDirty: state => state.app.modalDirty,
  onlineStatus: state => state.app.onlineStatus,
  language: state => state.app.language,
  surveys: state => state.data.surveys,
  selectDepartmentOptions : state => {
    const departmentOptions = [{
      label: '--------',
      value: null
    }]
    state.account.departments.forEach(item => departmentOptions.push({
      label: item.text,
      value: item.text
    }))
    return departmentOptions
  },
  selectPersonGroupsOptions: state => {
    const personGroupsOptions = [{
      label: '--------',
      value: null
    }]
    state.account.personGroups.forEach(item => personGroupsOptions.push({
      label: item.text,
      value: item.text
    }))
    return personGroupsOptions
  },
  selectSystemOptions: state => {
    const systemOptions = [{
      label: '--------',
      value: null
    }]
    state.account.systems.forEach(item => systemOptions.push({
      label: item.text,
      value: item.text
    }))
    return systemOptions
  },
  selectSupplierOptions: state => {
    const supplierOptions = [{
      label: '--------',
      value: null
    }]
    state.account.suppliers.forEach(item => supplierOptions.push({
      label: item.text,
      value: item.text
    }))
    return supplierOptions
  },
  selectDataTypeOptions: state => {
    const dataTypeOptions = [{
      label: '--------',
      value: null
    }]
    state.account.dataTypes.forEach(item => dataTypeOptions.push({
      label: item.text,
      value: item.text
    }))
    return dataTypeOptions
  }
}
export default getters
